import CreateNotifications from './create-notification';
import SendMail from './send-mail';
import TriggerWebhook from './trigger-webhook';

import options from './actions.component';

const Component = {
    selector: 'dtAlertsActionsContentActions',
    options
};

export {
    Component,
    CreateNotifications,
    SendMail,
    TriggerWebhook
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/actions/index.js